import React from "react";
import { NavLink } from "react-router-dom";

export default function Card({ ...currdata }) {
  return (
    <>
      <div
        className="card datacard"
        style={{
          width: "18rem",
          boxShadow:
            "rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px",
        }}
      >
        <img
          className="card-img-top"
          src={currdata.image}
          alt={currdata?.title}
          style={{ width: "18rem", height: "15rem" }}
        />
        <div className="card-body">
          <h6>{currdata?.title}</h6>
          <p className="card-text carddesc">{currdata?.desc}</p>
        </div>
        <NavLink
          className="btn btn-primary"
          to={currdata?.path}
          style={{ width: "fit-content", marginLeft: "110px", margin: "20px" }}
          role="button"
        >
          View
        </NavLink>
      </div>
    </>
  );
}
